/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'cross_product_search_dialog.atlas.tab_label': 'Atlas',
  'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
  'cross_product_search_dialog.confluence.tab_label': 'Confluence',
  'cross_product_search_dialog.google_drive.tab_label': 'ドライブ',
  'cross_product_search_dialog.google_drive.unauthenticated_prompt':
    'アトラシアンから離れることなく、すべての Google シート、ドキュメント、スライドなどで作業できます。このアクセス権を持つのはあなただけです。',
  'cross_product_search_dialog.jira.tab_label': 'Jira',
  'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
  'cross_product_search_dialog.recently_viewed_title': '最近表示した{sectionTitle}',
  'cross_product_search_dialog.townsquare_globex_tab_label': 'ホーム',
  'cross_product_search_dialog.townsquare_recent_goals': '最近のゴール',
  'cross_product_search_dialog.townsquare_recent_help_links': '最近閲覧したヘルプ リンク',
  'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': '最近の学習、リスク、意思決定',
  'cross_product_search_dialog.townsquare_recent_projects': '最近のプロジェクト',
  'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
  'cross_product_search_dialog.trello.tab_label': 'Trello',
  'cross_product_search_dialog.view_all_results_link': 'すべての {sectionTitle} を表示',
  'document-search-result.google-docs-label': 'ドキュメント',
  'document-search-result.google-sheets-label': 'スプレッドシート',
  'document-search-result.google-slides-label': 'スライド',
  'document-search-result.ms-excel-label': 'Excel',
  'document-search-result.ms-powerpoint-label': 'PowerPoint',
  'document-search-result.ms-word-label': 'Word',
  'extensible_search_dialog.advanced_search': '高度な検索',
  'extensible_search_dialog.connect': '接続',
  'extensible_search_dialog.connect_to': '接続先',
  'extensible_search_dialog.more': 'その他',
  'global_search.jira.advanced_search_boards': 'ボード',
  'global_search.jira.advanced_search_filters': 'フィルター',
  'global_search.jira.advanced_search_issues': '課題',
  'global_search.jira.advanced_search_issues-issue-term-refresh': '作業項目',
  'global_search.jira.advanced_search_label': 'すべて表示:',
  'global_search.jira.advanced_search_people': 'ユーザー',
  'global_search.jira.advanced_search_plans': 'プラン',
  'global_search.jira.advanced_search_projects': 'プロジェクト',
  'global_search.jira.search_placeholder': 'Jira を検索',
  'global_search.jira.search_placeholder_experiment_jsw_enabled': '課題、ボード、プロジェクト、フィルターを検索',
  'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh':
    '作業項目、ボード、プロジェクト、フィルターを検索',
  'product_s earch_dialog.confluence.assignee_filters_find_more': '担当者を検索',
  'product_search_dialog.atlas.search_input_expanded_placeholder': 'Atlas を検索',
  'product_search_dialog.autocorrection.label': '修正候補',
  'product_search_dialog.bitbucket.bitbucket_advanced_search': '{source} でコードを検索',
  'product_search_dialog.bitbucket.bitbucket_recent_repositories': '最近更新したリポジトリ',
  'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'リポジトリ',
  'product_search_dialog.bitbucket.expanded.input-placeholder': 'Bitbucket で検索',
  'product_search_dialog.bitbucket.repository_heading': 'リポジトリ',
  'product_search_dialog.common.site_filters': 'サイトで絞り込み',
  'product_search_dialog.compass.component_type.application': 'アプリ',
  'product_search_dialog.compass.component_type.capability': '機能',
  'product_search_dialog.compass.component_type.cloud_resource': 'Cloud リソース',
  'product_search_dialog.compass.component_type.data_pipeline': 'データ パイプライン',
  'product_search_dialog.compass.component_type.library': 'ライブラリ',
  'product_search_dialog.compass.component_type.machine_learning_model': '機械学習モデル',
  'product_search_dialog.compass.component_type.other': 'その他',
  'product_search_dialog.compass.component_type.service': 'サービス',
  'product_search_dialog.compass.component_type.ui_element': 'UI 要素',
  'product_search_dialog.compass.component_type.website': 'Web サイト',
  'product_search_dialog.compass.components_section_heading': 'コンポーネント',
  'product_search_dialog.compass.endpoints_section_heading': 'エンドポイント',
  'product_search_dialog.compass.expanded.input-placeholder': 'Compass を検索',
  'product_search_dialog.compass.people_section_heading': 'ユーザー',
  'product_search_dialog.compass.recently_viewed_components': '最近表示したコンポーネント',
  'product_search_dialog.compass.recently_viewed_endpoints': '最近表示したエンドポイント',
  'product_search_dialog.compass.recently_viewed_teams': '最近表示したチーム',
  'product_search_dialog.compass.tab_label': 'Compass',
  'product_search_dialog.compass.teams_section_heading': 'チーム',
  'product_search_dialog.compass.upsell_modal_cta_text': 'Compass を無料で入手',
  'product_search_dialog.compass.upsell_modal_description':
    'ソフトウェア アーキテクチャを一箇所でカタログ化しましょう。そうすれば、ソフトウェア アーキテクチャに取り組んでいるチームはコンテキストの切り替えを削減し、必要なものを素早く見つけて、生産性を高めることができます。開発者エクスペリエンスも向上します。',
  'product_search_dialog.compass.upsell_modal_description.bitbucket':
    'リポジトリの所有者、依存関係、ヘルプ リソースを確認するには、中央ソフトウェア カタログにそれらをリンクします。',
  'product_search_dialog.compass.upsell_modal_heading':
    'ソフトウェアのスプロール化を制御して、開発者が時間を管理できるようにしましょう',
  'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'コードにもっと多くのコンテキストを取り込む',
  'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Compass の詳細',
  'product_search_dialog.compass.upsell_modal_learn_more_link': '詳細',
  'product_search_dialog.compass.upsell_tab_title_lozenge': 'NEW',
  'product_search_dialog.compass.view_all_components_label': 'すべてのコンポーネントを表示',
  'product_search_dialog.compass.view_all_results_label': 'すべての結果を表示',
  'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence の高度な検索',
  'product_search_dialog.confluence.clear_filters': 'フィルターを解除',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.description':
    'あなたのチームは Confluence でコラボレーションしています。ページ、ホワイトボード、データベースを使用して、チームのナレッジを整理し、アイデアを収集し、Jira プロジェクトの要件を共有しましょう。',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.header':
    'あなたのチームは現在 Confluence を使用しています',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': 'チームに参加',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': '詳細',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results': 'さらに結果を表示',
  'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': 'さらに結果を表示',
  'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': '無料アクセス',
  'product_search_dialog.confluence.content_section_heading': 'コンテンツ',
  'product_search_dialog.confluence.contributor_filters': '投稿者で絞り込み',
  'product_search_dialog.confluence.contributor_filters_find_more': '投稿者を検索',
  'product_search_dialog.confluence.date_filter_title': '最終更新日',
  'product_search_dialog.confluence.date_filter_today': '今日',
  'product_search_dialog.confluence.date_filter_yesterday': '昨日',
  'product_search_dialog.confluence.date_filters_any': '指定なし',
  'product_search_dialog.confluence.date_filters_month': '過去 30 日間',
  'product_search_dialog.confluence.date_filters_week': '過去 7 日間',
  'product_search_dialog.confluence.date_filters_year': '過去 1 年間',
  'product_search_dialog.confluence.empty_state_body_no_advanced_search':
    '別のキーワードを試すか、キーワードの数を減らすか、より一般的なキーワードをお試しください。',
  'product_search_dialog.confluence.empty_state_body_prequery_filters':
    '選択したフィルターで、過去 90 日間に作成または更新されたデータが見つかりません。',
  'product_search_dialog.confluence.empty_state_body_title': '検索条件に一致する結果が見つかりませんでした。',
  'product_search_dialog.confluence.filters_applied': 'フィルターが適用されているようです。',
  'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'ページ、ブログ、添付ファイル',
  'product_search_dialog.confluence.people_section_heading': 'ユーザー',
  'product_search_dialog.confluence.search_input_expanded_placeholder': 'Confluence を検索',
  'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Confluence 内で検索または質問する',
  'product_search_dialog.confluence.space_filters': 'スペースで絞り込み',
  'product_search_dialog.confluence.space_filters_find_more': 'スペースを検索',
  'product_search_dialog.confluence.spaces_section_heading': 'スペース',
  'product_search_dialog.confluence.typing_state_header_text': 'Confluence でコンテンツを検索する',
  'product_search_dialog.cross_product.expanded.input-placeholder': 'すべてを検索',
  'product_search_dialog.cross_product.recents.section_heading': '最近表示',
  'product_search_dialog.cross_product.results.section_heading': '検索結果',
  'product_search_dialog.cross_product.tab_label': 'すべて',
  'product_search_dialog.empty.no_results_body':
    '別の用語でもう一度試すか、結果を [<a>高度な検索</a>] で絞り込みます。',
  'product_search_dialog.empty.no_results_body_with_no_advanced_search': '別の検索語句でもう一度お試しください。',
  'product_search_dialog.empty.no_results_heading': '検索条件に一致する結果が見つかりませんでした。',
  'product_search_dialog.empty_prequery.error_heading': '最初の結果を表示する際に問題が発生しました',
  'product_search_dialog.empty_prequery.no_results_heading': '必要なものを検索',
  'product_search_dialog.error.failed_loading_search_body':
    '問題が発生したようです。ページを更新するか、<emptyLink>もう一度お試しください。</emptyLink>',
  'product_search_dialog.error.failed_loading_search_heading':
    '最近閲覧したコンテンツの読み込み中に問題が発生しました。',
  'product_search_dialog.give_feedback': 'フィードバックを送信',
  'product_search_dialog.google_drive.files_heading': 'ファイル',
  'product_search_dialog.inline_onboarding_action': 'OK',
  'product_search_dialog.inline_onboarding_body':
    'Jira タブと Confluence タブを使用して、いずれかの場所にある最近のアイテムを検索および表示します。',
  'product_search_dialog.inline_onboarding_title': 'Jira と Confluence 全体を検索',
  'product_search_dialog.jira.assignee_filters': '担当者で絞り込み',
  'product_search_dialog.jira.boards_icon_accessibility_text': 'ボードのアイコン',
  'product_search_dialog.jira.boards_projects_filters_plans_section_heading':
    'ボード、プロジェクト、フィルター、プラン',
  'product_search_dialog.jira.boards_projects_filters_section_heading': 'ボード、プロジェクト、フィルター',
  'product_search_dialog.jira.date_filter_30': '30 日',
  'product_search_dialog.jira.date_filter_60': '60 日',
  'product_search_dialog.jira.date_filter_90': '90 日',
  'product_search_dialog.jira.date_filter_any': '指定なし',
  'product_search_dialog.jira.date_filter_past_30_days': '過去 30 日間',
  'product_search_dialog.jira.date_filter_past_7_days': '過去 7 日間',
  'product_search_dialog.jira.date_filter_past_year': '過去 1 年間',
  'product_search_dialog.jira.date_filter_today': '今日',
  'product_search_dialog.jira.date_filter_yesterday': '昨日',
  'product_search_dialog.jira.date_filters': '最終更新日',
  'product_search_dialog.jira.empty_prequery.no_results_heading': 'ここから検索してタスクや作業を見つけましょう',
  'product_search_dialog.jira.issue_filter_done': '完了',
  'product_search_dialog.jira.issue_filter_open': 'オープン',
  'product_search_dialog.jira.issue_filters': 'ステータスで絞り込み',
  'product_search_dialog.jira.issue_labels_filters': 'ラベルで絞り込む',
  'product_search_dialog.jira.issue_labels_filters_options_group_label': 'すべてのラベル',
  'product_search_dialog.jira.issue_labels_filters_placeholder': 'ラベルを選択',
  'product_search_dialog.jira.issues_section_heading': '課題',
  'product_search_dialog.jira.issues_section_heading-issue-term-refresh': '作業項目',
  'product_search_dialog.jira.jira_view_all_issues_new': 'すべての課題を表示',
  'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'すべての作業項目を表示',
  'product_search_dialog.jira.project_filters': 'プロジェクトで絞り込み',
  'product_search_dialog.jira.project_filters_find_more': 'プロジェクトを検索',
  'product_search_dialog.jira.projects_filters_section_heading': 'プロジェクトおよびフィルター',
  'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading':
    '最近使ったボード、プロジェクト、フィルター、プラン',
  'product_search_dialog.jira.recent_boards_projects_filters_section_heading':
    '最近使ったボード、プロジェクト、フィルター',
  'product_search_dialog.jira.recent_projects_filters_section_heading': '最近使ったプロジェクトとフィルター',
  'product_search_dialog.jira.recently_viewed_issues_section_heading': '最近表示した課題',
  'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': '最近表示した作業項目',
  'product_search_dialog.jira.report_by_filters': '報告者でフィルター',
  'product_search_dialog.jira.reported_by_me_filter': '自分が報告した課題',
  'product_search_dialog.jira.site_filters_find_more': 'サイトを探す',
  'product_search_dialog.loading_filters': '読み込み中',
  'product_search_dialog.more_filters': 'すべてのフィルターを表示',
  'product_search_dialog.multi_site_advanced_search_label': '検索対象:',
  'product_search_dialog.multi_site_advanced_search_more_dropdown': 'あと {count} 個',
  'product_search_dialog.no_options_filters': 'オプションなし',
  'product_search_dialog.opsgenie.advanced_search': '高度なアラート検索',
  'product_search_dialog.opsgenie.alert_heading': 'アラート',
  'product_search_dialog.opsgenie.expanded.input-placeholder': 'Opsgenie を検索',
  'product_search_dialog.opsgenie.opsgenie_recent_alerts': '最近のアラート',
  'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Atlassian Intelligence に質問する',
  'product_search_dialog.quick_find_confluence_space': 'Confluence スペース',
  'product_search_dialog.quick_find_footer_full_page_search_products_link': '複数製品を検索',
  'product_search_dialog.quick_find_footer_help_text': '検索の改善にご協力ください',
  'product_search_dialog.quick_find_no_content_body_rovo':
    'アトラシアン製品と統合製品で探しているものを検索するか、Rovo に質問してください',
  'product_search_dialog.quick_find_no_content_header': '検索して見つけましょう',
  'product_search_dialog.quick_find_post_query_no_results_body':
    '<SearchContentLink>組織内のすべてのコンテンツを検索</SearchContentLink>するか、別の語句でやり直してください。',
  'product_search_dialog.quick_find_post_query_no_results_header': 'このタイトルを含む結果は見つかりませんでした',
  'product_search_dialog.quick_find_recent_draft_label': 'ドラフト',
  'product_search_dialog.quick_find_recent_search': '最近の検索',
  'product_search_dialog.quick_find_recent_search_text_dialog': '最近の検索から',
  'product_search_dialog.quick_find_recent_spaces_additional_meta': '最近閲覧しました',
  'product_search_dialog.quick_find_recently_viewed': '最近の表示履歴',
  'product_search_dialog.quick_find_result_item_team': 'チーム',
  'product_search_dialog.quick_find_results_section': '検索結果',
  'product_search_dialog.quick_find_rovo_tip':
    '「休暇制度について教えてください」のような質問を入力すると、Rovo が答えを見つけてくれます。',
  'product_search_dialog.quick_find_search_input_rovo_placeholder': '検索するか、Rovo に質問してください',
  'product_search_dialog.quick_find_search_results': '検索結果',
  'product_search_dialog.quick_find_show_filtered_confluence_results': 'Confluence スペース、投稿者などで絞り込む',
  'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon':
    '{confluenceIcon} Confluence スペース、投稿者などで絞り込む',
  'product_search_dialog.quick_find_show_organization_results': '自分の組織を検索',
  'product_search_dialog.recent_spaces_section_heading': '最近のスペース',
  'product_search_dialog.recently_viewed_heading': '高度な検索',
  'product_search_dialog.recently_viewed_section_heading': '最近表示',
  'product_search_dialog.recently_worked_with_section_heading': '最近一緒に作業した人',
  'product_search_dialog.results.remove_button_label': 'この項目を削除',
  'product_search_dialog.search_input_collapsed_placeholder': '検索',
  'product_search_dialog.search_input_enlarged_aria_label': 'Enter キーを押すと詳細検索に移動します',
  'product_search_dialog.search_people_link': 'ユーザーを検索',
  'product_search_dialog.show_all_results_link': 'すべての結果を表示',
  'product_search_dialog.show_more_results_link': '表示を増やす',
  'product_search_dialog.townsquare.search_input_expanded_placeholder': 'ホームを検索',
  'product_search_dialog.townsquare_goals_heading': 'ゴール',
  'product_search_dialog.townsquare_goals_view_all': 'すべてのゴールを検索',
  'product_search_dialog.townsquare_help_links_heading': 'ヘルプ リンク',
  'product_search_dialog.townsquare_learnings_risks_decisions_heading': '学習、リスク、意思決定',
  'product_search_dialog.townsquare_people_heading': 'ユーザー',
  'product_search_dialog.townsquare_people_view_all': 'すべてのユーザーを検索',
  'product_search_dialog.townsquare_projects_heading': 'プロジェクト',
  'product_search_dialog.townsquare_projects_view_all': 'すべてのプロジェクトを検索',
  'product_search_dialog.townsquare_recent_people': '最近検索したユーザー',
  'product_search_dialog.townsquare_recent_topics': '最新トピック',
  'product_search_dialog.townsquare_teams_heading': 'チーム',
  'product_search_dialog.townsquare_teams_view_all': 'すべてのチームを検索',
  'product_search_dialog.townsquare_topics_heading': 'トピック',
  'product_search_dialog.townsquare_topics_view_all': 'すべてのトピックを検索',
  'product_search_dialog.trello.archived': 'アーカイブ済み',
  'product_search_dialog.trello.archived.card-hover': 'このカードはアーカイブされています。',
  'product_search_dialog.trello.board': 'ボード',
  'product_search_dialog.trello.boards_heading': 'ボード',
  'product_search_dialog.trello.cards_heading': 'カード',
  'product_search_dialog.trello.closed': 'クローズ済み',
  'product_search_dialog.trello.closed.board-hover': 'このボードは閉じています。',
  'product_search_dialog.trello.expanded.input-placeholder': 'Trello を検索',
  'product_search_dialog.trello.feedback_link': '検索結果の品質向上にご協力ください。',
  'product_search_dialog.trello.list': 'リスト',
  'product_search_dialog.trello.private_workspace': '非公開ワークスペース',
  'product_search_dialog.trello.recent_boards_heading': '最近使用したボード',
  'product_search_dialog.trello.workspace': 'ワークスペース',
  'product_search_dialog.updated_date_formatter': '更新日: {date}',
  'search_dialog.filters.group.show-more': '表示を増やす',
  'search_dialog.search_input_clear_label': '検索セッションをクリア',
  'search_dialog.search_input_exit_label': '検索を終了',
};
